import type {
  Image as SanityImage,
  SanityImageAsset,
  SanityImageAssetQuery,
  SanityImageAssetQueryVariables,
} from '@/.generated/sanityTypes/graphql'
import { sanityImageAssetQuery } from '@/app/[locale]/[year]/query'
import { request } from '@/lib/sanityClient'

// For some reason the generated Sanity type does not not include _ref
type ImageAssetWithRef = SanityImageAsset & {
  _ref?: string
}

export async function resolveImageAssetReference(asset: ImageAssetWithRef) {
  const { data } = await request<
    SanityImageAssetQuery,
    SanityImageAssetQueryVariables
  >(sanityImageAssetQuery, { id: asset._ref! })
  return data?.SanityImageAsset!
}

export function getImageObjectPosition(image?: SanityImage | null): string {
  return image?.hotspot
    ? `${(image.hotspot.x ?? 0.5) * 100}% ${(image.hotspot.y ?? 0.5) * 100}%`
    : '50% 50%'
}
